import {Injectable} from '@angular/core';
import {AlarmLevel} from '../model/alarm-level.model';
import {ApiService} from './api.service';
import {retryAfterMillis} from '../shared/constants';
import {utf8Decode} from 'sdv-common';

@Injectable({providedIn: 'root'})
export class AlarmLevelService {

  private levels: AlarmLevel[] = [];

  constructor(private apiService: ApiService) {
    this.load();
  }

  load() {
    this.apiService.get('alarm-levels', {
      $limit: 1000,
      $offset: 0
    }).subscribe(response => {
      const levels: AlarmLevel[] = [];
      for (const alarmLevel of response) {
        levels.push(this.covertAlarmLevel(alarmLevel));
      }
      this.levels = levels;
    }, err => {
      this.apiService.error({}, err);
      setTimeout(() => this.load(), retryAfterMillis);
    });
  }

  private covertAlarmLevel(alarmLevel) {
    return {
      id: alarmLevel.id || 0,
      system: alarmLevel.system || false,
      name: utf8Decode(alarmLevel.name || '')
    };
  }

  getLevels() {
    return this.levels;
  }
}
